/*
 * Optional Radio Click events
 * TODO: Is not used anymore?
 */
var addons = function (column) {
    var $ = jQuery;
    var $column = column.$el;
    var inputs = $column.find('[data-trigger] label');
    inputs.on('click', function () {
        var id = $(this).closest('td.input').data('trigger');
        var state = $('input', this).val();
        // Toggle indicator icon
        var label = $column.find('[data-indicator-id="' + id + '"]').removeClass('on');
        if ('on' === state) {
            label.addClass('on');
        }
        // Toggle additional options
        var additional = $column.find('[data-handle="' + id + '"]').addClass('hide');
        if ('on' === state) {
            additional.removeClass('hide');
        }
    });
    // On load
    $column.find('[data-trigger]').each(function () {
        var trigger = $(this).data('trigger');
        // Hide additional column settings
        var additional = $column.find('[data-handle="' + trigger + '"]').addClass('hide');
        if ('on' === $('input:checked', this).val()) {
            additional.removeClass('hide');
        }
    });
};
export default addons;
